import React, { Component } from "react";
import moment from "moment";
//import { Link } from 'react-router-dom';
import Table from "./common/table";

const $ = require("jquery");
$.DataTable = require("datatables.net");

class CreditsTable extends Component {
  columns = [
    {
      path: "user_email",
      label: "To:",
      content: (credit) => credit.user_email,
    },
    { path: "amount", label: "Amount:" },
    { path: "order_ref", label: "Order Ref" },
    { path: "trade_reference", label: "Trade Ref" },
    { path: "processed_by", label: "Credited By:" },
    {
      path: "transaction_date",
      label: "Txn Date",
      content: (credit) =>
        moment(credit.transaction_date).startOf("day").format("LL"),
    },
  ];

  componentDidMount() {
    $(document).ready(function () {
      $("#dataTable").DataTable();
    });
  }

  render() {
    const { credits, message } = this.props;
    return <Table columns={this.columns} data={credits} message={message} />;
  }
}

export default CreditsTable;
